import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { AdalService } from '../shared/azure-authentication/adal.service';
import { SearchService } from '../shared/search.service';
import { LoanAssignment } from './loanassignment.model';
import { LoanAssignmentService } from './loanassignment.service';

@Component({
  selector: 'app-loanassignment',
  templateUrl: './loanassignment.component.html',
  styleUrls: ['./loanassignment.component.css']
})
export class LoanAssignmentComponent implements OnInit {

    public searchText: string;
    private logs: LoanAssignment[];
    private filteredLogs: LoanAssignment[];
    private searchKeyUp = new Subject<string>();

    constructor(private adalService: AdalService, private loanAssignmentService: LoanAssignmentService, private searchService: SearchService)
    {
        // debounce the search to be more efficent
        const observable = this.searchKeyUp
            .map(value => event)
            .debounceTime(300)
            .distinctUntilChanged()
            .flatMap((search) => {
                return Observable.of(search).delay(150);
            })
            .subscribe((data) => {
                this.onKeySearch(data);
            });
    }

    ngOnInit() {
        this.loanAssignmentService.getRecentLogs().then(logs => {
            this.logs = logs;
            this.filteredLogs = logs;
            this.formatTimestamps();
        });
    }

    formatTimestamps() {
        const dp: DatePipe = new DatePipe('en-US');
        this.logs.forEach(log => {
            log.timeStampDisplay = dp.transform(log.timeStamp + 'Z', "MM-dd-yyyy hh:mm:ss a Z");
        });
         
    }

    onKeySearch(event: any) {
        if (this.searchText.length > 0) {
            this.searchService.emitSearchEvent(this.searchText);
            this.filteredLogs = this.logs.filter(log => log.loanNumber.includes(this.searchText) || log.roleEffected.includes(this.searchText));
        }

        if (this.searchText.length === 0) {
            this.searchService.emitClearSearchEvent();
            this.filteredLogs = this.logs;
        }

    }

    onClearSearch(event: any) {
        this.searchText = '';
        this.filteredLogs = this.logs;
        this.searchService.emitClearSearchEvent();
    }
}



// WEBPACK FOOTER //
// D:/a/1/s/Uhm.Loops.Web/src/app/loan-assignment/loanassignment.component.ts